import Vuex from 'vuex';

const state = {
	markers: [],
    filteredMarkers: [],
    mapName: '',
	filterByOffices: false,
	filterByShowRooms: false,
	hasOffices: false,
	hasShowrooms: false,
};

const getters = {
  getFilteredMarkers: state => state.filteredMarkers,
  hasOffices: state => state.hasOffices,
  hasShowrooms: state => state.hasShowrooms,
};

const actions = {
	addMarker: ({ state, commit }, marker) => {
		commit('addMarker', marker)
	},
	filter: ({state, commit}) => {

		let filters = [];

		if(state.filterByOffices) {
			filters.push('office');
		}

		if(state.filterByShowrooms) {
			filters.push('showroom');
		}

		let filteredMarkers = [];

		if(filters.length > 0) {
			filteredMarkers = state.markers.filter(marker => {
				return filters.includes(marker.tooltipContent.type.toLowerCase());
		});
		} else {
			filteredMarkers = state.markers;
		}


		if(filteredMarkers.length > 0) {
			commit('showFilteredMarkers', filteredMarkers);
		}
	},
	filterByOffices: ({ state, commit, dispatch}, filter ) => {
		commit('filterByOffices', filter);
		dispatch('filter');
	},
	filterByShowrooms: ({ state, commit, dispatch}, filter ) => {
		commit('filterByShowrooms', filter);
		dispatch('filter');
	},
	search: ({ state, commit }, searchTerm) => {
		if(searchTerm.length == 0 && state.markers.length != state.filteredMarkers.length) {
			commit('showFilteredMarkers', state.markers);
		} else {
			const filteredMarkers = state.markers.filter((marker) => {
				var arr = Object.values(marker.tooltipContent);
				return arr.join('').toLowerCase().indexOf(searchTerm.toLowerCase()) != -1;
			});
			commit('showFilteredMarkers', filteredMarkers);
		}
	},
};

const mutations = {
	addMarker: (state, marker) => {
		if(marker.tooltipContent.type.toLowerCase() == 'office' && !state.hasOffices) {
			state.hasOffices = true;
		}
		if(marker.tooltipContent.type.toLowerCase() == 'showroom' && !state.hasShowrooms) {
			state.hasShowrooms = true;
		}
		state.markers.push(marker);
		state.filteredMarkers.push(marker);
	},
	showFilteredMarkers: (state, markers) => {
		state.filteredMarkers = markers;
	},
	filterByOffices: (state, filter) => {
		state.filterByOffices = filter;
	},
	filterByShowrooms: (state, filter) => {
		state.filterByShowrooms = filter;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};



// WEBPACK FOOTER //
// ./store/modules/googlemap.js